/* 單篇最新消息內頁。 */
(function () {
  const articles = window.RIEASE_NEWS || [];
  const root = document.getElementById('article-root');
  if (!root) return;

  const slug = new URLSearchParams(window.location.search).get('id');
  const article = articles.find((item) => item.slug === slug);

  if (!article) {
    document.title = '找不到文章｜RiEASE 睿鍶科技';
    root.innerHTML = `
      <div class="article-error">
        <span class="article-kicker">ARTICLE NOT FOUND</span>
        <h1>找不到這篇文章</h1>
        <p>文章可能已移動，請回到最新消息查看其他內容。</p>
        <a href="news.html" class="cta-btn">回到最新消息</a>
      </div>`;
    return;
  }

  const displayTitle = article.title.replace(/([：:])\s*/, '$1<br>');
  document.title = `${article.title}｜RiEASE 睿鍶科技`;
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) descriptionMeta.content = article.description;
  const canonical = document.querySelector('link[rel="canonical"]');
  const articleUrl = `https://www.riease.com/news-article.html?id=${encodeURIComponent(article.slug)}`;
  const articleImage = `https://www.riease.com/${article.image}`;
  if (canonical) canonical.href = articleUrl;

  const setMeta = (selector, content) => {
    const meta = document.querySelector(selector);
    if (meta) meta.content = content;
  };
  setMeta('meta[property="og:title"]', article.title);
  setMeta('meta[property="og:description"]', article.description);
  setMeta('meta[property="og:url"]', articleUrl);
  setMeta('meta[property="og:image"]', articleImage);

  const toc = article.sections.map((section, index) => `
    <li><a href="#section-${index + 1}">${String(index + 1).padStart(2, '0')}　${section.title}</a></li>`).join('');

  const sections = article.sections.map((section, index) => `
    <section class="article-section" id="section-${index + 1}">
      <span class="article-section-index">SECTION ${String(index + 1).padStart(2, '0')}</span>
      <h2>${section.title}</h2>
      ${(section.paragraphs || []).map((paragraph) => `<p>${paragraph}</p>`).join('')}
      ${section.bullets ? `<ul class="article-bullets">${section.bullets.map((item) => `<li>${item}</li>`).join('')}</ul>` : ''}
    </section>`).join('');

  const sources = article.sources.length ? `
    <section class="article-sources" aria-labelledby="article-sources-title">
      <h2 id="article-sources-title">REFERENCES</h2>
      ${article.sources.map((source) => `<a class="article-source" href="${source.url}" target="_blank" rel="noopener noreferrer"><span>${source.label}</span><span aria-hidden="true">↗</span></a>`).join('')}
    </section>` : '';

  const related = articles
    .filter((item) => item.slug !== article.slug)
    .sort((a, b) => Number(b.category === article.category) - Number(a.category === article.category))
    .slice(0, 3);

  root.style.setProperty('--article-accent', article.accent);
  root.innerHTML = `
    <article>
      <header class="article-hero">
        <div class="article-breadcrumb"><a href="index.html">首頁</a> ／ <a href="news.html">最新消息</a> ／ ${article.categoryLabel}</div>
        <span class="article-kicker">${article.label}</span>
        <h1 class="article-title">${displayTitle}</h1>
        <p class="article-deck">${article.deck}</p>
        <div class="article-meta"><span>${article.displayDate}</span><span>${article.categoryLabel}</span><span>${article.readingTime}</span><span>RIEASE EDITORIAL</span></div>
      </header>
      <figure class="article-image-wrap">
        <img src="${article.image}" alt="${article.imageAlt}" width="1568" height="1003" fetchpriority="high">
        <figcaption class="article-image-note">RIEASE EDITORIAL VISUAL</figcaption>
      </figure>
      <div class="article-layout">
        <aside class="article-toc" aria-label="文章目錄">
          <span class="article-toc-label">ON THIS PAGE</span>
          <ol>${toc}</ol>
        </aside>
        <div class="article-content">
          <section class="article-takeaways">
            <h2>KEY TAKEAWAYS</h2>
            <ul>${article.takeaways.map((item) => `<li>${item}</li>`).join('')}</ul>
          </section>
          ${sections}
          ${sources}
        </div>
      </div>
    </article>
    <section class="related-news">
      <div class="related-news-inner">
        <div class="related-news-heading"><span class="article-kicker">KEEP READING</span><h2>延伸閱讀</h2></div>
        <div class="related-news-grid">
          ${related.map((item) => `
            <a class="related-news-card" href="news-article.html?id=${encodeURIComponent(item.slug)}">
              <div class="related-news-card-image"><img src="${item.image}" alt="" loading="lazy"></div>
              <small>${item.categoryLabel}　${item.displayDate}</small>
              <h3>${item.title}</h3>
              <span>閱讀文章 ↗</span>
            </a>`).join('')}
        </div>
      </div>
    </section>`;

  const jsonLd = document.createElement('script');
  jsonLd.type = 'application/ld+json';
  jsonLd.text = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    datePublished: article.date,
    dateModified: article.date,
    image: `https://www.riease.com/${article.image}`,
    author: { '@type': 'Organization', name: '睿鍶科技股份有限公司' },
    publisher: { '@type': 'Organization', name: '睿鍶科技股份有限公司' }
  }).replace(/</g, '\\u003c');
  document.head.appendChild(jsonLd);
})();